export const calculateTimeLeft = (
  resendCodeCount: number,
  resendDate: number,
): number => {
  const now = Date.now() / 1000;
  const elapsed = now - resendDate;

  const waitTimes: Record<number, number> = {
    1: 2 * 60,
    2: 5 * 60,
    3: 30 * 60,
  };

  const waitTime = waitTimes[resendCodeCount] ?? 0;
  return Math.max(waitTime - elapsed, 0);
};

export const formatTime = (seconds: number) => {
  const totalSeconds = Math.floor(seconds);
  const m = Math.floor(totalSeconds / 60).toString();
  const s = (totalSeconds % 60).toString().padStart(2, "0");

  return `${m}:${s}`;
};
